<script lang="ts" setup>
    import TagsList from '@shared/components/Tags/TagsList.vue';
    import JourneyPreview from '../Pages/JourneyPreview.vue';
    import { type TagsProvide } from '@shared/components/Tags/TagsTypes';
    import Alert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/bsAlerts';
    import { type Journey } from '@journeys/journeys';
    import JourneyListItemStats from './JourneyListItemStats.vue';
    import JourneyListItemMeta from './JourneyListItemMeta.vue';
    import { computed } from 'vue';

const props = defineProps<{
        journey: Journey;
        index: number;
        tags?: TagsProvide;
        currentTab?: string;
        hideStats?: boolean;
        hideAbortedIssuesAlert?: boolean;
    }>();

    const emit = defineEmits<{
        journeyClicked: [];
        reactivateAbortedIssuesBtnClicked: [issues: any[]];
    }>();

    const showAbortedIssuesAlert = computed(() => {
        return !props.hideAbortedIssuesAlert && props.currentTab !== 'drafts' && props.journey.Issues?.find((i) => i.Status === 60);
    });
</script>

<template>
    <div class="card-media">
        <JourneyPreview :index="index" :key="props.journey.JourneyId" :journey="props.journey" @click.prevent="$emit('journeyClicked')" />
    </div>
    <div class="flex-1 card-content">
        <h4>
            <a :href="'/journeys/' + props.journey.JourneyId" @click.prevent="$emit('journeyClicked')">{{ props.journey.Title || $Resources.NoTitleLabel }}</a>
        </h4>

        <p v-if="props.journey.Description">
            {{ props.journey.Description }}
        </p>

        <TagsList
            v-if="props.tags && props.journey.data.Tags.length > 0"
            :tags="props.journey.data.Tags"
            :selectedIds="props.tags.state.selectedIds"
            @toggleTag="(tag) => props.tags!.toggle(tag)"></TagsList>

        <JourneyListItemMeta :journey="props.journey" />

        <Alert
            v-if="showAbortedIssuesAlert"
            class="m-sm-t m-xs-b"
            :type="AlertTypes.Warning"
            :title="$Resources.JourneyHasAbortedIssuesAlertTitle"
            :content="$Resources.JourneyHasAbortedIssuesAlertContent"
            :buttonText="$Resources.JourneyHasAbortedIssuesAlertButton"
            :dismissible="false"
            @buttonClick="emit('reactivateAbortedIssuesBtnClicked', props.journey.Issues!)"></Alert>
    </div>

    <JourneyListItemStats v-if="!hideStats" :journeyId="props.journey.JourneyId" />
</template>
